import {
  call, put, takeEvery, select, takeLatest,
} from 'redux-saga/effects';
import axios from '../axiosConfig';
import {
  autocompleteRequest,
  hotelAutocompleteRequest,
  autocompleteSuccess,
  autocompleteFail,
  cacheAutocompleteResponse,
} from '../../slices/autocomplete';

const queryString = require('query-string');

function* autocompleteWorker({
  payload: {
    autocompleteTypes,
    query,
    responseType,
    cruiseLineIds = null,
    key,
  },
}) {
  try {
    const autocompleteTypesURL = autocompleteTypes.map((type) => `types=${type}`).join('&');
    const queryURL = query ? `&${queryString.stringify({ query })}` : '';
    const cruiseLinesURL = cruiseLineIds ? `&${queryString.stringify({ cruiseLineIds })}` : '';
    const keyParam = key ? `&key=${key}` : '';
    const url = `/autocomplete?${autocompleteTypesURL}${queryURL}${cruiseLinesURL}${keyParam}`;
    const config = {
      method: 'get',
      url,
    };
    const retryLimit = 1; // workaround for autocomplete API issues

    let data = yield select((state) => state.autocomplete.autocompleteCache[url]);
    if (!query || !data || !data[0].suggests.length) {
      // eslint-disable-next-line no-plusplus
      for (let retryCount = 0; retryCount < retryLimit; retryCount++) {
        const response = yield call(axios, config);
        data = response.data.groups;
        if (!query || (data && data[0].suggests.length)) {
          break;
        }
      }
      yield put(cacheAutocompleteResponse({ url, responseData: data }));
    }
    yield put(autocompleteSuccess({ data, responseType }));
  } catch (error) {
    yield put(autocompleteFail({ data: 'errorAutocomplete', responseType: 'error' }));
  }
}

function* autocompleteWatcher() {
  yield takeEvery(autocompleteRequest.toString(), autocompleteWorker);
  yield takeLatest(hotelAutocompleteRequest.toString(), autocompleteWorker);
}

export default autocompleteWatcher;
